import React from "react";
import VehicleCard from "./VehicleCard";
import VehicleListRow from "./VehicleListRow";
import ItemCard from "./ItemCard";
import ItemListRow from "./ItemListRow";

export default function PackageCard({
  pkg,
  onSaveLabel,
  canEditLabel = false,
  canRemoveIngame = false,
  viewMode = 'card',
}) {
  const isListView = viewMode === 'list';
  const vehicleContainerClass = isListView ? 'vehicle-list' : 'package-vehicles';
  const itemContainerClass = isListView ? 'item-list' : 'item-grid';
  const VehicleComponent = isListView ? VehicleListRow : VehicleCard;
  const ItemComponent = isListView ? ItemListRow : ItemCard;

  return (
    <div className="package-card">
      <h3 className="package-title">{pkg.packageName}</h3>

      {pkg.vehicles?.length > 0 && (
        <div className={vehicleContainerClass}>
          {pkg.vehicles.map((v, i) => (
            <VehicleComponent
              key={i}
              v={v}
              onSaveLabel={onSaveLabel}
              canEditLabel={canEditLabel}
              canRemoveIngame={canRemoveIngame}
            />
          ))}
        </div>
      )}

      {pkg.items?.length > 0 && (
        <div className="package-items">
          <div className={itemContainerClass}>
            {pkg.items.map((i, idx) => (
              <ItemComponent key={idx} item={i} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
